import createReducer, { ActionCreatorHelper } from '@hh.ru/redux-create-reducer';
import { YearMonthDayString } from 'bloko/blocks/calendar/datesHelper';

import { MonthNumber } from 'src/types';

export type IntervalNameTrlKey = 'week' | 'twoWeek' | 'month' | 'quarter' | 'halfYear' | 'year' | MonthNumber;

export enum IntervalName {
    CurrentYear = 'currentYear',
    PreviousYear = 'previousYear',
    CurrentFullMonth = 'currentFullMonth',
    PreviousFullMonth = 'previousFullMonth',
    PrePreviousFullMonth = 'prePreviousFullMonth',
    LastYear = 'lastYear',
    LastHalfYear = 'lastHalfYear',
    LastQuarter = 'lastQuarter',
    LastMonth = 'lastMonth',
    LastWeek = 'lastWeek',
    LastTwoWeek = 'lastTwoWeek',
}

interface Interval {
    start: YearMonthDayString;
    end: YearMonthDayString;
    trlKey: IntervalNameTrlKey;
}

export interface PreparedDates {
    firstAvailableDate: YearMonthDayString;
    lastAvailableDate: YearMonthDayString;
    intervals: {
        [IntervalName.CurrentYear]: Interval;
        [IntervalName.PreviousYear]: Interval;
        [IntervalName.CurrentFullMonth]: Interval;
        [IntervalName.PreviousFullMonth]: Interval;
        [IntervalName.PrePreviousFullMonth]: Interval;
        [IntervalName.LastYear]: Interval;
        [IntervalName.LastHalfYear]: Interval;
        [IntervalName.LastQuarter]: Interval;
        [IntervalName.LastMonth]: Interval;
        [IntervalName.LastWeek]: Interval;
        [IntervalName.LastTwoWeek]: Interval;
    };
}

const INITIAL_STATE = {} as PreparedDates;

const SET_FILTER_AVAILABLE_DATES = 'SET_FILTER_AVAILABLE_DATES';

interface PayloadTypes {
    [SET_FILTER_AVAILABLE_DATES]: Partial<PreparedDates>;
}

const actionCreator = ActionCreatorHelper<PayloadTypes>();

export const setAvailableDates = actionCreator(SET_FILTER_AVAILABLE_DATES);

export default createReducer<PreparedDates, PayloadTypes>(INITIAL_STATE, {
    [SET_FILTER_AVAILABLE_DATES]: (state, { payload }) => {
        const firstAvailableDate = payload?.firstAvailableDate ?? state.firstAvailableDate;
        const lastAvailableDate = payload?.lastAvailableDate ?? state.lastAvailableDate;

        const newState: PreparedDates = {
            ...state,
            firstAvailableDate,
            lastAvailableDate,
        };
        return newState;
    },
});
